import { FieldRow, FieldRows, FieldValue } from '@/features/settings/components/FieldRow';
import { ReadOnlyTag } from '@/features/settings/components/ReadOnlyTag';
import { useAuth } from '@/contexts/auth-context';

export function ProfileSection() {
  const { me } = useAuth();

  return (
    <FieldRows>
      <FieldRow label="Display name" description="The name teammates see on your activity.">
        <FieldValue>{me.name}</FieldValue>
        <ReadOnlyTag />
      </FieldRow>
      <FieldRow label="Email" description="Used to sign you in and to reach you about your account.">
        <FieldValue>{me.email}</FieldValue>
        <ReadOnlyTag />
      </FieldRow>
    </FieldRows>
  );
}
